import { render } from "./Reports.vue?vue&type=template&id=67c78596"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__